import { Filter } from "api";
import { logicalOperators } from "components/FilterSection/Filter/Filter";
import { SelectOptions } from "hooks";

export interface FilterViewModel {
    id?: Readonly<string>;
    translation?: Readonly<string>;
    name: string;
    type?: string;
    options?: SelectOptions[];
    operator: string;
    logicalOperator?: string;
}

/**
 * Create filters for server
 * @param filters
 */
export const remapFilters = (filters: FilterViewModel[]): Filter[] => {
    return filters.map(({ name, options, operator, type }) => {
        return {
            name,
            // TODO: this should be assign on the view
            type,
            values: options?.map(({ value }) => value) || [],
            operator,
        };
    });
};

/**
 * Create filter for view
 * @param filter
 */
export const remapViewFilters = (filter?: Filter[]): FilterViewModel[] => {
    if (!filter) {
        return [];
    }

    return filter.map<FilterViewModel>(({ name, values = [], operator, translation, type }) => {
        return {
            name,
            translation,
            options: values.map((value) => {
                return {
                    name: value,
                    value,
                };
            }),
            type,
            operator,
            logicalOperator: logicalOperators[1].value, // TODO: missing on the server
        };
    });
};
